import React, { useState, useEffect } from 'react';
import { trackDayLocked } from '../utils/analytics';
import { getScore, getTotalStars } from '../utils/completionStorage';
import { sound } from '../utils/sound';

interface LockedDayPopupProps {
  message: string;
  day: number;
  onClose: () => void;
  header?: string;
  isDayOff?: boolean;
}

const LockedDayPopup: React.FC<LockedDayPopupProps> = ({ message, day, onClose, header = 'Day Locked', isDayOff = false }) => {
  const [isClosing, setIsClosing] = useState(false);

  // Track day locked popup and play locked sound on mount
  useEffect(() => {
    sound.locked();
    trackDayLocked({
      day,
      total_score: getScore(),
      total_stars: getTotalStars()
    });
  }, []);

  const handleClose = () => {
    sound.clickOpen();
    setIsClosing(true);
    setTimeout(() => {
      onClose();
    }, 200); // Match animation duration
  };

  return (
    <div className={`locked-popup-overlay ${isClosing ? 'closing' : ''}`} onClick={handleClose}>
      <div className={`locked-popup-content ${isClosing ? 'closing' : ''}`} onClick={(e) => e.stopPropagation()}>
        <div className="locked-popup-header">
          <h2>{header}</h2>
        </div>
        <div className="locked-popup-body">
          <p>{message}</p>
        </div>
        <button className="locked-popup-close" onClick={handleClose}>
          OK
        </button>
      </div>
    </div>
  );
};

export default LockedDayPopup;
